import { useState } from "react";

import { Box } from "@chakra-ui/react";
import { isEmpty } from "lodash";

import {
  Editable,
  EditableField,
  EditablePreview,
  Input,
  useIsDirty,
} from "@/components/form";

import { EditableFieldLabel } from "./editable-field-label";
import { EditableFieldProps } from "./types";

export const KeywordsEditableField = ({
  defaultValue,
  isReadOnly = false,
  onChange,
  onSave,
  onCancel,
}: EditableFieldProps<string>) => {
  const [nextValue, setNextValue] = useState(defaultValue);

  const isDirty = useIsDirty(defaultValue || "", nextValue || "");

  return (
    <Box w="full">
      <EditableFieldLabel isDirty={isDirty}>Keywords</EditableFieldLabel>

      <Editable
        label="Keywords"
        isReadOnly={isReadOnly}
        hasValue={!isEmpty(defaultValue)}
        onSave={async () => {
          await onSave?.(nextValue);
        }}
        onCancel={() => {
          setNextValue(defaultValue);
          onCancel?.();
        }}
      >
        <EditablePreview>{defaultValue}</EditablePreview>

        <EditableField>
          <Input
            w="full"
            size="md"
            value={nextValue || ""}
            onChange={(value) => {
              setNextValue(value);
              onChange?.(value);
            }}
          />
        </EditableField>
      </Editable>
    </Box>
  );
};
